var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6947_146589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.643253 8C0.642225 7.93442 0.658853 7.86941 0.692068 7.80913C0.725282 7.74885 0.774348 7.69465 0.83611 7.65L6.62182 3.15C6.87897 2.95 7.27754 2.95 7.53468 3.15C7.79182 3.35 7.79182 3.66 7.53468 3.86L2.19897 8.01L7.52182 12.15C7.77897 12.35 7.77897 12.66 7.52182 12.86C7.26468 13.06 6.86611 13.06 6.60897 12.86L0.823253 8.36C0.694682 8.26 0.630396 8.13 0.630396 8.01L0.643253 8Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6947_146589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 9,
    fill: "white",
    transform: "matrix(0 1 -1 0 9 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.0efefbd5b1c0935a13834645853d005f.svg";
export { ForwardRef as ReactComponent };